import { observable, action, computed } from 'mobx';

export class ProductImageSliderViewController {
    @observable private currentSlide: number = 0;
    @observable private nextSlide: number = 0;

    @computed
    public get data() {
        return {
            currentSlide: this.currentSlide,
            nextSlide: this.nextSlide
        };
    }

    @action
    public setCurrentSlide = (newIndex: number) => {
        this.currentSlide = newIndex;
    };

    @action
    public setNextSlide = (oldIndex: number, newIndex: number) => {
        this.nextSlide = newIndex;
    };
}
